import { Text } from '@lune-fe/lune-ui-lib'
import { SxProps } from '@mui/material'
import Box from '@mui/material/Box'
import { FC } from 'react'

// Copied from: https://github.com/lune-climate/lune-backend/blob/e86c61b2c091ae67d19bd0e49e003e7b62aead7c/src/emissionFactorCategoryFallbacks.ts#L226
const categoryToEmissionFactorMap = new Map<string, string[]>([
    ['accommodation', ['Accommodation', 'Hotel and restaurant services (55)']],
    ['advertising services', ['Advertising and public relations', 'Other business services (74)']],
    ['agriculture', ['Crops nec', 'Other crop farming']],
    ['air transportation', ['Air transport', 'Air transport services (62)']],
    ['beverages: alcoholic', ['Alcoholic beverages - 02.1']],
    ['beverages: non-alcoholic', ['Beverages', 'Non-alcoholic beverages - 01.2']],
    ['catering services', ['Food and beverage serving services - 11.1']],
    ['ceramic products', ['Clay and ceramic products', 'Ceramic goods']],
    ['chemicals and chemical products', ['Chemicals nec']],
    ['clothing', ['Clothing', 'Clothing (Primary material production)', 'Clothing - 03.1']],
    ['cloud computing', ['Data processing and hosting', 'Computer and related services (72)']],
    [
        'commercial and industrial waste',
        [
            'Refuse - Commercial and industrial waste (Landfill)',
            'Inert/metal/hazardous waste for treatment: landfill',
        ],
    ],
    ['construction', ['Construction work (45)']],
    ['construction materials', ['Cement, lime and plaster', 'Concrete pipe, bricks, and blocks']],
    [
        'construction waste',
        ['Construction - Concrete (Landfill)', 'Waste concrete', 'Construction work (45)'],
    ],
    [
        'consumer goods rental',
        [
            'Renting services of machinery and equipment without operator and of personal and household goods (71)',
            'General and consumer goods rental',
        ],
    ],
    [
        'cultural services',
        [
            'Recreational, cultural and sporting services (92)',
            'Other amusement and recreation industries',
            'Golf courses, marinas, ski resorts, fitness and other rec centers and industries',
        ],
    ],
    [
        'dairy products',
        ['Dairies', 'Dairy products', 'Milk, other dairy products and eggs (nd) - 01.1.4', 'Dairy'],
    ],
    [
        'domestic services',
        ['Domestic services and household services (s) - 05.6.2', 'Other personal services'],
    ],
    ['education services', ['Education services (80)', 'Other educational services']],
    ['electrical equipment', ['Electrical machinery and apparatus n.e.c. (31)']],
    ['electronic products', ['Computers', 'Household appliances - 05.3']],
    [
        'financial services',
        [
            'Services auxiliary to financial intermediation (67)',
            'Financial services - 12.2',
            'Business support services',
            'Funds, trusts, and financial vehicles',
        ],
    ],
    ['fish and seafood', ['Seafood', 'Fish products', 'Fish and other seafood (nd) - 01.1.3']],
    [
        'fishing activities',
        [
            'Fishing, hunting and trapping',
            'Fish and other fishing products; services incidental of fishing (05)',
        ],
    ],
    [
        'food processing',
        ['Ready-made food and other food products n.e.c. (nd) - 01.1.9', 'Food - 01.1'],
    ],
    ['footwear', ['Footwear - 03.2']],
    [
        'wood materials',
        [
            'Wood and products of wood and cork (except furniture); articles of straw and plaiting materials (20)',
        ],
    ],
    [
        'forestry activities',
        [
            'Products of forestry, logging and related services (02)',
            'Agriculture and forestry support',
            'Forestry and logging',
        ],
    ],
    ['fruits and vegetables', ['Vegetables, fruit, nuts']],
    ['fuel', ['Gas (nd) - 04.5.2', 'Motor Gasoline']],
    ['furniture', ['Furniture', 'Furniture; other manufactured goods n.e.c. (36)']],
    [
        'gardening services',
        [
            'Tools and equipment for house and garden - 05.5',
            'Lawn and garden equipment',
            'Garden products and pets - 09.3',
        ],
    ],
    ['glass', ['Glass and glass products']],
    [
        'government services',
        ['Public administration and defence services; compulsory social security services (75)'],
    ],
    [
        'grains and grain products',
        ['Wheat', 'Cereal grains nec', 'Fresh wheat, corn, rice, and other grains'],
    ],
    [
        'heat and steam',
        [
            'Steam and hot water supply services',
            'Other energy for heating and cooling (nd) - 04.5.5',
        ],
    ],
    [
        'home appliances',
        ['Household appliances - 05.3', 'Household appliances and electrical and electronic goods'],
    ],
    [
        'household waste',
        ['Residual household waste Landfill - Impacts', 'Food waste for treatment: landfill'],
    ],
    ['information and communication services', ['Information and communication - 08']],
    ['infrastructure', ['Utilities buildings and infrastructure']],
    ['land use change', ['Land use change, annual crop', 'Other services (93)']],
    ['legal services', ['Legal services', 'Other business services (74)']],
    ['business services', ['Other business services (74)']],
    [
        'livestock',
        [
            'Cattle',
            'Meat animals nec',
            'Cattle ranches and feedlots',
            'Live animals, meat and other parts of slaughtered land animals (nd) - 01.1.2',
        ],
    ],
    ['machinery', ['Machinery and equipment n.e.c. (29)']],
    ['meat, poultry and eggs', ['Meat products nec', 'Poultry']],
    [
        'medical products',
        [
            'Medicines and health products - 06.1',
            'Medical, precision and optical instruments, watches and clocks (33)',
        ],
    ],
    [
        'medical services',
        [
            'Health and social work services (85)',
            'Inpatient care services - 06.3',
            'Outpatient care services - 06.2',
        ],
    ],
    ['metal manufacturing', ['Fabricated metal products, except machinery and equipment (28)']],
    [
        'metals',
        [
            'Lead, zinc and tin ores and concentrates',
            'Basic iron and steel and of ferro-alloys and first products thereof',
        ],
    ],
    [
        'mining activities',
        [
            'Stone mining and quarrying',
            'Coal mining',
            'Chemical and fertilizer minerals, salt and other mining and quarrying products n.e.c.',
        ],
    ],
    ['natural materials', ['Secondary raw materials', 'Sand and clay']],
    ['nuts and seeds', ['Fruits and nuts (nd) - 01.1.6', 'Fresh fruits and tree nuts']],
    ['office supplies', ['Office machinery and computers (30)', 'Office supplies (not paper)']],
    [
        'oils and fats',
        [
            'Oils and fats (nd) - 01.1.5',
            'products of Vegetable oils and fats',
            'Vegetable oils and by-products',
        ],
    ],
    ['packaging', ['Light gauge metal cans, boxes, and containers']],
    ['paint', ['Paints and coatings']],
    ['paper products', ['Paper', 'Paper and paper products']],
    [
        'personal care products',
        ['Personal care - 13.1', 'Health and personal care stores', 'Personal care services'],
    ],
    [
        'pharmaceutical products',
        [
            'Drugs and druggists sundries',
            'Medicines and health products - 06.1',
            'Pharmaceutical products (pills, powders, solutions, etc.)',
        ],
    ],
    [
        'plants',
        [
            'Greenhouse crops, mushrooms, nurseries, and flowers',
            'Garden products and pets - 09.3',
            'Greenhouse, nursery, and floriculture production',
        ],
    ],
    ['plastics', ['Plastics', 'Plastics, basic', 'Rubber and plastic products (25)']],
    [
        'publishing services',
        [
            'Books, newspapers, magazines, and other print media',
            'Internet publishing and broadcasting and Web search portals',
        ],
    ],
    ['rail transportation', ['Rail transportation', 'Railway transportation services']],
    [
        'ready-made food and other food products',
        [
            'Ready-made food and other food products n.e.c. (nd) - 01.1.9',
            'Food products nec',
            'Food - 01.1',
            'Food and drink (Primary material production)',
        ],
    ],
    [
        'recreational services',
        [
            'Recreational, cultural and sporting services (92)',
            'Recreational services - 09.4',
            'Recreation, sport and culture - 09',
            'Other amusement and recreation industries',
        ],
    ],
    [
        'refrigerants and fugitive gases',
        [
            'Liquefied Petroleum Gases (LPG)',
            'Air conditioning, refrigeration, and warm air heating equipment',
        ],
    ],
    [
        'restaurants',
        [
            'Full-service restaurants',
            'All other food and drinking places',
            'Hotel and restaurant services (55)',
        ],
    ],
    ['parking', ['Other land transportation services']],
    [
        'road transportation',
        [
            'Passenger transport by road (s) - 07.3.2',
            'Other land transportation services',
            'Truck transport',
        ],
    ],
    [
        'sports products',
        ['Sporting and athletic goods', 'Sports', 'Recreation, sport and culture - 09'],
    ],
    ['storage', ['Warehousing and storage', 'Transport services of goods - 07.4']],
    [
        'sugar, confectionery and desserts',
        ['Sugar, confectionery and desserts (nd) - 01.1.8', 'Sugar, candy, and chocolate', 'Sugar'],
    ],
    ['textiles', ['Textiles (17)', 'Fabric']],
    ['tobacco products', ['Tobacco products (16)', 'Tobacco - 02.3', 'Tobacco products']],
    [
        'utilities',
        [
            'Distribution and trade services of electricity',
            'Water supply and miscellaneous services relating to the dwelling - 04.4',
            'Electricity (nd) - 04.5.1',
        ],
    ],
    [
        'vehicle maintenance and services',
        ['Vehicle repair', 'Maintenance and repair of personal transport equipment (s) - 07.2.3'],
    ],
    [
        'vehicle parts',
        [
            'Motor vehicle and parts dealers',
            'Sale, maintenance, repair of motor vehicles, motor vehicles parts, motorcycles, motor cycles parts and accessoiries',
        ],
    ],
    [
        'waste management',
        [
            'Other waste for treatment: waste water treatment',
            'Inert/metal/hazardous waste for treatment: landfill',
            'Food waste for treatment: landfill',
        ],
    ],
    ['water', ['Collected and purified water, distribution services of water (41)']],
    [
        'water transportation',
        ['Sea and coastal water transportation services', 'Inland water transportation services'],
    ],
])

const emissionCsvToCategoryFallback: Record<string, string> = {
    'agriculture & farming': 'agriculture',
    contractors: 'construction',
    airlines: 'air transportation',
    'car rentals': 'vehicle maintenance and services',
    hotels: 'accommodation',
    transportation: 'road transportation',
    utilities: 'utilities',
    'retail & grocery': 'ready-made food and other food products',
    clothing: 'clothing',
    'other shops': 'business services',
    'business services': 'business services',
    'professional services & orgs': 'business services',
    'government services': 'government services',
    'other services': 'recreational services',
    'hospitality services': 'restaurants',
    'storage and warehousing': 'storage',
    'materials & manufacturing': 'metal manufacturing',
    'land use & construction': 'construction',
    electronics: 'electronic products',
    'waste & gasses': 'waste management',
}

const normalize = (s: string) =>
    s
        .normalize('NFKD')
        .toLowerCase()
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[’'"]/g, '')
        .replace(/&/g, 'and')
        .replace(/[\s/_-]+/g, ' ')
        .trim()

type CategoryIndex = {
    normalizedToCategoryName: Map<string, string>
}

const buildCategoryIndex = (): CategoryIndex => {
    const normalizedToCategoryName = new Map<string, string>()

    // 1) keys + aliases from categoryToEmissionFactorMap
    for (const [key, aliases] of categoryToEmissionFactorMap.entries()) {
        for (const label of [key, ...(aliases ?? [])]) {
            const n = normalize(label)
            const existing = normalizedToCategoryName.get(n)
            if (!existing) {
                normalizedToCategoryName.set(n, key)
            }
        }
    }

    // 2) CSV fallbacks (normalize keys)
    for (const [k, v] of Object.entries(emissionCsvToCategoryFallback)) {
        const n = normalize(k)
        if (!normalizedToCategoryName.has(n)) {
            normalizedToCategoryName.set(n, v)
        }
    }

    return { normalizedToCategoryName }
}
export const categoryIndex = buildCategoryIndex()

export const resolveCategoryName = (raw: string): string | null => {
    const n = normalize(raw)
    return categoryIndex.normalizedToCategoryName.get(n) ?? null
}

export const categoryColorHexMap = new Map<string, string>([
    ['accommodation', '#FFE175'],
    ['advertising services', '#B77EFF'],
    ['agriculture', '#FFB967'],
    ['air transportation', '#0099F1'],
    ['beverages: alcoholic', '#E57EFF'],
    ['beverages: non-alcoholic', '#69DFC9'],
    ['catering services', '#FFE175'],
    ['ceramic products', '#3BC9F0'],
    ['chemicals and chemical products', '#69DFC9'],
    ['clothing', '#FDF07D'],
    ['cloud computing', '#69DFC9'],
    ['commercial and industrial waste', '#8D8DBD'],
    ['construction', '#FFB967'],
    ['construction materials', '#FFB967'],
    ['construction waste', '#8D8DBD'],
    ['consumer goods rental', '#FFB8D8'],
    ['cultural services', '#E57EFF'],
    ['dairy products', '#FFE175'],
    ['domestic services', '#FFB8D8'],
    ['education services', '#87BDF8'],
    ['electrical equipment', '#FDF07D'],
    ['electronic products', '#69DFC9'],
    ['financial services', '#69DFC9'],
    ['fish and seafood', '#0099F1'],
    ['fishing activities', '#0099F1'],
    ['food processing', '#FF7759'],
    ['footwear', '#FFB967'],
    ['forestry activities', '#C4FD9E'],
    ['fruits and vegetables', '#C4EB9E'],
    ['fuel', '#0099F1'],
    ['furniture', '#FF7759'],
    ['gardening services', '#C4EB9E'],
    ['glass', '#3BC9F0'],
    ['government services', '#87BDF8'],
    ['grains and grain products', '#FFE175'],
    ['heat and steam', '#FFB967'],
    ['home appliances', '#FFE175'],
    ['household waste', '#8D8DBD'],
    ['information and communication services', '#BDBDBD'],
    ['infrastructure', '#BDBDBD'],
    ['land use change', '#FF7759'],
    ['legal services', '#87BDF8'],
    ['business services', '#87BDF8'],
    ['livestock', '#FF7759'],
    ['machinery', '#8D8DBD'],
    ['meat, poultry and eggs', '#FF7759'],
    ['medical products', '#FF4343'],
    ['medical services', '#FF4343'],
    ['metal manufacturing', '#3BC9F0'],
    ['metals', '#3BC9F0'],
    ['mining activities', '#BDBDBD'],
    ['natural materials', '#FFB967'],
    ['nuts and seeds', '#FFE175'],
    ['office supplies', '#FFB967'],
    ['oils and fats', '#FDF07D'],
    ['packaging', '#FFB967'],
    ['paint', '#0099F1'],
    ['paper products', '#FFB967'],
    ['personal care products', '#FFE175'],
    ['pharmaceutical products', '#FF4343'],
    ['plants', '#C4EB9E'],
    ['plastics', '#3BC9F0'],
    ['publishing services', '#B77EFF'],
    ['rail transportation', '#FFB967'],
    ['ready-made food and other food products', '#FF7759'],
    ['recreational services', '#E57EFF'],
    ['refrigerants and fugitive gases', '#69DFC9'],
    ['restaurants', '#FFE175'],
    ['road transportation', '#BDBDBD'],
    ['sports products', '#FFE175'],
    ['storage', '#FFE175'],
    ['sugar, confectionery and desserts', '#FDF07D'],
    ['textiles', '#E57EFF'],
    ['tobacco products', '#FFB867'],
    ['utilities', '#FDF07D'],
    ['vehicle maintenance and services', '#3BC9F0'],
    ['vehicle parts', '#3BC9F0'],
    ['waste management', '#8D8DBD'],
    ['water', '#0099F1'],
    ['water transportation', '#0099F1'],
    ['parking', '#BDBDBD'],
])

export const CategoryChip: FC<{
    category: string
    sx?: SxProps
}> = ({ category, sx }) => {
    const resolved = resolveCategoryName(category) ?? category
    const hex = categoryColorHexMap.get(resolved) ?? '#EEEEEE'

    return (
        <Box
            title={resolved}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                px: 1,
                py: 1 / 2,
                borderRadius: '100px',
                backgroundColor: hex + '33',
                lineHeight: 1,
                whiteSpace: 'nowrap',
                textTransform: 'capitalize',
                ...sx,
            }}
        >
            <Box
                sx={{
                    width: '8px',
                    maxWidth: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    flex: '1 0 8px',
                    backgroundColor: hex,
                }}
            />
            <Text
                variant={'body3'}
                sx={{
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                }}
            >
                {resolved}
            </Text>
        </Box>
    )
}

export default CategoryChip
